module.exports = __webpack_public_path__ + "img/cancun-bay-room.ac0fe412.jpg";